import styled from 'styled-components';

import Image from '../../../components/Image';

const Logo = styled(Image)`
  margin: 0 auto;
`;

export default Logo;
